(function ($) {

    $(document).ready(function () {

        $("#menu-principal-desktop-page-cdr nav > ul li[class^='icon-']").on("click", function (e) {
            console.log(e);
            var link = e.target.childNodes[0].href;
            console.log('link: ', link);
            window.location.href = link;

        });

    });

})(jQuery);